/**
 * Starter sequence templates — pre-wired node graphs the user can drop in
 * from Step 1 of the wizard. These do NOT touch the backend EmailTemplate
 * collection; they are just convenience starting points for the builder.
 */
const mkId = (prefix) => `${prefix}_${Math.random().toString(36).slice(2, 8)}`;

export const STARTER_TEMPLATES = [
  {
    key: 'volunteer_welcome',
    name: 'Volunteer Welcome',
    category: 'Volunteers',
    description: 'Send a welcome email when someone signs up to volunteer.',
    icon: '🤝',
    triggerEvent: 'volunteer_registration_submitted',
    build () {
      const start = mkId('start');
      const email = mkId('email');
      return {
        nodes: [
          { id: start, type: 'start', position: { x: 60, y: 80 }, data: { label: 'Volunteer signup' } },
          {
            id: email, type: 'sendEmail', position: { x: 320, y: 80 },
            data: {
              label: 'Welcome email',
              subject: 'Welcome to the Black Heart Association, {{firstName}}!',
              html: '<p>Hi {{firstName}},</p><p>Thank you for volunteering with the Black Heart Association. We\'ll be in touch soon with next steps.</p><p>— The BHA Team</p>',
              recipientField: 'email'
            }
          }
        ],
        edges: [{ id: mkId('e'), source: start, target: email }]
      };
    }
  },
  {
    key: 'booking_confirmation',
    name: 'Booking Confirmation',
    category: 'Bookings',
    description: 'Confirm appointments the moment a client books.',
    icon: '📅',
    triggerEvent: 'event_booking_created',
    build () {
      const start = mkId('start');
      const email = mkId('email');
      return {
        nodes: [
          { id: start, type: 'start', position: { x: 60, y: 80 }, data: { label: 'Booking created' } },
          {
            id: email, type: 'sendEmail', position: { x: 320, y: 80 },
            data: {
              label: 'Confirmation email',
              subject: 'Your appointment is confirmed — {{confirmationCode}}',
              html: '<p>Hi {{firstName}},</p><p>Your appointment for <strong>{{eventName}}</strong> on {{appointmentDate}} at {{appointmentTime}} is confirmed.</p><p>Confirmation code: <strong>{{confirmationCode}}</strong></p>',
              recipientField: 'email'
            }
          }
        ],
        edges: [{ id: mkId('e'), source: start, target: email }]
      };
    }
  },
  {
    key: 'screening_followup',
    name: 'Screening Follow-Up',
    category: 'Screenings',
    description: 'Thank patients for completing a bus screening.',
    icon: '❤️',
    triggerEvent: 'bus_screening_submitted',
    build () {
      const start = mkId('start');
      const email = mkId('email');
      return {
        nodes: [
          { id: start, type: 'start', position: { x: 60, y: 80 }, data: { label: 'Screening submitted' } },
          {
            id: email, type: 'sendEmail', position: { x: 320, y: 80 },
            data: {
              label: 'Thank-you email',
              subject: 'Thanks for visiting our screening, {{firstName}}',
              html: '<p>Hi {{firstName}},</p><p>Thank you for completing your screening with the Black Heart Association. We appreciate you taking time for your heart health.</p>',
              recipientField: 'email'
            }
          }
        ],
        edges: [{ id: mkId('e'), source: start, target: email }]
      };
    }
  },
  {
    key: 'survey_thanks',
    name: 'Survey Thank-You',
    category: 'Surveys',
    description: 'Acknowledge survey responses with a quick thank-you.',
    icon: '📝',
    triggerEvent: 'survey_response_completed',
    build () {
      const start = mkId('start');
      const email = mkId('email');
      return {
        nodes: [
          { id: start, type: 'start', position: { x: 60, y: 80 }, data: { label: 'Survey response' } },
          {
            id: email, type: 'sendEmail', position: { x: 320, y: 80 },
            data: {
              label: 'Thank-you email',
              subject: 'Thanks for your feedback, {{firstName}}',
              html: '<p>Hi {{firstName}},</p><p>Thank you for completing the {{surveyTitle}} survey. Your input helps us improve heart health in our community.</p>',
              recipientField: 'email'
            }
          }
        ],
        edges: [{ id: mkId('e'), source: start, target: email }]
      };
    }
  },
  {
    key: 'blank',
    name: 'Blank Sequence',
    category: 'General',
    description: 'Start from scratch with just a Start node.',
    icon: '⚡',
    triggerEvent: '',
    build () {
      const start = mkId('start');
      return {
        nodes: [{ id: start, type: 'start', position: { x: 80, y: 80 }, data: { label: 'Start' } }],
        edges: []
      };
    }
  }
];

export const STARTER_CATEGORIES = ['All', 'Volunteers', 'Screenings', 'Bookings', 'Surveys', 'General'];
